import parseJson from "../parse-json";
import {BackendFetch, LegacyOrder} from '@hantera/portal-app';
import cache from "./cache";

export interface SearchResult {
  orders: LegacyOrder[]
}

export interface SearchHit {
  id: string
  type: 'order'
  label: string
}

export interface NewSearchResult {
  orders: LegacyOrder[]
}

export default function (portalFetch: BackendFetch) {

  return {
    /**
     * Quick search for entities
     */
    async search(phrase: string, signal: AbortSignal): Promise<SearchResult> {
      const res = await portalFetch('/search', {
        method: 'POST',
        body: JSON.stringify({
          phrase,
        }),
      });

      if (res.status === 200) {
        const result = parseJson(await res.text()) as SearchResult;

        result.orders.forEach(o => {
          cache.legacyOrders.addOrUpdate(o);
        });

        return result;
      }
      return {
        orders: [],
      };
    },
    /**
     * Quick search for entities (new core beta version)
     */
    async searchNew(phrase: string, signal: AbortSignal): Promise<SearchResult> {
      const res = await portalFetch('/search', {
        method: 'POST',
        signal: signal,
        body: JSON.stringify({
          new: true,
          phrase,
        }),
      });

      if (res.status === 200) {
        const result = parseJson(await res.text()) as SearchResult;

        // Core uses a different format for orders, so they can't be used for caching

        return result;
      }
      return {
        orders: [],
      };
    },
  }
}